var render = function () {
  var _vm$chipItems;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScroll,
      expression: "onScroll"
    }],
    staticClass: "header-sheet flex-shrink-1",
    class: {
      'auto-hide': _vm.autoHide
    },
    style: {
      top: !_vm.autoHide ? 0 : _vm.showHeader ? ((_vm.$vuetify.application.top) + "px") : '-500px'
    },
    attrs: {
      "color": "transparent",
      "tile": "",
      "width": "100%"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-column align-center justify-center",
    attrs: {
      "color": _vm.backgroundColor || undefined,
      "tile": "",
      "width": "100%"
    }
  }, [_c('h1', {
    staticClass: "title-font font-weight-bold text-center mt-4 mb-8",
    style: {
      color: _vm.titleColor || _vm.$vuetify.theme.themes.light.primary
    }
  }, [_vm._v(_vm._s(_vm.titleText))]), (_vm$chipItems = _vm.chipItems) !== null && _vm$chipItems !== void 0 && _vm$chipItems.length ? _c('v-chip-group', {
    staticClass: "chip-group d-flex align-center justify-center pb-2",
    attrs: {
      "center-active": "",
      "show-arrows": "",
      "value": _vm.value
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  }, _vm._l(_vm.chipItems, function (item) {
    return _c('v-chip', _vm._b({
      key: item.key,
      staticClass: "mx-2 font-weight-bold text-body-1",
      attrs: {
        "color": item.slug === _vm.value ? _vm.titleColor : _vm.backgroundColor,
        "outlined": item.slug !== _vm.value,
        "text-color": item.slug === _vm.value ? _vm.backgroundColor : _vm.titleColor,
        "value": item.slug
      }
    }, 'v-chip', Object.assign({}, _vm.chipDefaults, _vm.chipProps), false), [_c('v-icon', {
      attrs: {
        "left": ""
      }
    }, [_vm._v(_vm._s(item.icon))]), _c('span', {
      staticClass: "ml-1"
    }, [_vm._v(_vm._s(item.label))])], 1);
  }), 1) : _vm._e()], 1), _c('v-sheet', {
    staticClass: "fade",
    style: {
      'mask-image': ("linear-gradient(" + (_vm.backgroundColor) + ", transparent)")
    },
    attrs: {
      "height": "40px",
      "width": "100%",
      "color": _vm.backgroundColor || 'transparent'
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }